// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hook';
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
// components
import Logo from 'src/components/logo';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'Explore',
    children: [
      { name: 'Contact', href: paths.supportPath.contact },
      // { name: 'Security', href: paths.securityPage },
      { name: 'FAQs', href: paths.supportPath.faqs },
      { name: 'View Documentation', href: paths.docs.overview },
    ],
  },
  {
    headline: 'ST Workbench',
    children: [
      { name: 'Login', href: paths.auth.firebase.login },
      { name: 'Register for Beta User', href: paths.auth.firebase.register },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Impressum', href: paths.legal.impressum },
      { name: 'Terms of Service', href: paths.legal.termsOfService },
      { name: 'Privacy Policy', href: paths.legal.privacyPolicy },
      { name: 'Cookie Policy', href: paths.legal.cookiePolicy },
      { name: 'Data Processing Agreement', href: paths.legal.dataProcessingAgreement },
      { name: 'EAA Contractual Clauses', href: paths.legal.eeaStandardContactualClauses },
      { name: 'Disclaimer', href: paths.legal.disclaimer },
    ],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const pathname = usePathname();

  const isHome = pathname === '/';

  const simpleFooter = (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: 'center',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Container>
        <Logo sx={{ mb: 1, mx: 'auto' }} />

        <Typography variant="caption" component="div">
          © All rights reserved
          <br /> made by
          <Link href="/">Visit SimpleTranslate Homepage</Link>
        </Typography>
      </Container>
    </Box>
  );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              Our Salesforce Translation Tools are simple to use and integrate seamlessly into your
              existing workflows, whether youre translating metadata or data.
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  href={social.path}
                  key={social.name}
                  target='blank'
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={8}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Box
                      component="a"
                      key={link.name}
                      href={link.href}
                      sx={{
                        color: 'inherit',
                        fontSize: '0.75rem',
                        lineHeight: 1.57,
                        textDecoration: 'none',
                        transition: 'text-decoration 0.2s ease-in-out',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      {link.name}
                    </Box>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © 2024. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  // return !isHome ? simpleFooter : mainFooter;
  return mainFooter;
}
